<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>{{ isNewVendorReview ? 'Add' : 'Edit' }} Vendor Review</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <app-vendor-review-questions
          [VendorReview]="yourVendorRating"
          [readOnly]="false"
        ></app-vendor-review-questions>
      </div>
      <div class="modal-footer">
        <div class="col-2">
          <button type="button" class="btn btn-danger" (click)="closeModal()">
            Cancel
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            (click)="addEditReview()"
          >
            {{ isNewVendorReview ? 'Add' : 'Edit' }} Review
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
